import { useEffect, useRef, useState, useCallback } from 'react';
import { useSwipeable } from 'react-swipeable';
// import { useSoundEffects } from '@tmsw/powerups.audio.hooks.use-sound-effects';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { useStore } from '@tmsw/powerups.store';
import { HexUtils } from '..//HexGrid/HexUtils';
import GameCarouselItem from './GameCarouselItem/GameCarouselItem';
import { useLevelContext } from '../../hooks/useLevel/provider';
import './GameCarousel.css';

function GameCarousel(props) {
  const { __t } = useTranslation('GAME_PLAY');

  const {
    carouselItems,
    handleOnDrop,
    updateSelected,
    // itemsToShow,
    gridItemProps,
    carouselRef,
    board,
    // playSfx
  } = props;

  const viewport = useStore((state) => state.viewport);
  const { state } = useLevelContext();
  const selectedHex = state.metadata.selected;
  console.log('selectedHex', selectedHex);

  const sliderRef = useRef(null);
  const itemCountRef = useRef(carouselItems.length);

  // console.log('gridItemProps', gridItemProps);

  const { tile } = gridItemProps;

  const calculateStyles = useCallback(
    () => ({
      container: {
        width: carouselRef.current
          ? carouselRef.current.getBoundingClientRect().width
          : 'auto',
      },
      leftPadding: tile?.width ? tile?.width / 2 : 0,
      gridColumnGap: tile?.width ? tile?.width / 5 : 0,
      item: {
        flexBasis: tile?.width ? `${tile?.width}px` : 'inherit',
      },
      piece: {
        width: tile?.width ? `${tile?.width}px` : '100%',
        height: tile?.height ? `${tile?.height}px` : '100%',
      },
    }),
    [tile]
  );

  const [styles, setStyles] = useState(() => calculateStyles());

  const [scrollIndex, setScrollIndex] = useState(0);

  const updateScrollIndex = (v) => {
    if (scrollIndex !== v) {
      setScrollIndex(v);
    }
  };

  const calculate = () => {
    const containerWidth = styles.container.width;
    const nItems = carouselItems.length;
    // const slideWidth = scrollWidth / nItems + 16;
    const slideWidth = tile.width;
    // const slideWidth = gridItemProps.width + styles.gridColumnGap;
    const scrollWidth = slideWidth * nItems + styles.leftPadding;
    // const scrollWidth = sliderRef.current.scrollWidth;
    // const scrollOffset = slideWidth * 1/2;
    const scrollOffset = containerWidth / 2 - slideWidth / 2;
    return { scrollWidth, nItems, slideWidth, containerWidth, scrollOffset };
  };

  const focusCarouselItemByIndex = (index) => {
    const itemEl = sliderRef.current.children[index];
    itemEl.click();
    itemEl.focus();
  };

  const handleTranslation = ({ direction, autoFocus }) => {
    if (!sliderRef.current) return;
    const { scrollWidth, nItems, slideWidth } = calculate();
    let newScrollIndex = scrollIndex + direction;
    if (newScrollIndex < 0) newScrollIndex = 0;
    if (newScrollIndex >= nItems) newScrollIndex = nItems - 1;

    console.log('styles', styles);
    console.log('scrollWidth=', scrollWidth, 'slideWidth=', slideWidth);
    // if (nItems <= itemsToScoll) {
    //   sliderRef.current.style.transform = `translateX(0px)`;
    // } else if (newScrollIndex <= 0) {
    //   sliderRef.current.style.transform = `translateX(0px)`;
    // if (newScrollIndex >= nItems) {
    //   sliderRef.current.style.transform = `translateX(${scrollWidth}}px)`;
    // } else {
    let scrollAmount = newScrollIndex * slideWidth;
    sliderRef.current.style.transform = `translateX(${-scrollAmount}px)`;
    // }

    const edgeHit =
      newScrollIndex >= itemCountRef.current || newScrollIndex < 0;

    if (edgeHit) {
      // sfx.current.player('menuEnd').start();
    }

    updateScrollIndex(newScrollIndex);

    if (autoFocus && !edgeHit) {
      focusCarouselItemByIndex(newScrollIndex);
    }
  };

  const handleOnSwipe = (eventData) => {
    const direction = eventData.dir === 'Right' ? -1 : 1;
    return handleTranslation({ direction, autoFocus: true });
  };

  /**
   *
   * @param {*} event
   * @returns
   */
  const handleSelection = (event) => {
    event.preventDefault();

    let buttonEl =
      document.activeElement.tagName === 'BUTTON'
        ? document.activeElement
        : event.target.tagName === 'BUTTON'
        ? event.target
        : event.target.querySelector('BUTTON');

    if (!buttonEl) {
      console.log('ERR! ', event.target);
      return;
    }

    buttonEl.parentNode.focus();
    updateSelected({ id: buttonEl.value });
  };

  /**
   * @name handleCarouselKeydown
   * @param {Event} event
   *
   * Handle carousel keyboard traversal
   *  [Tab, Shift-Tab]: Navigate left or right; Updates focus; Ignored at edge cases
   *  [ArrowRight, KeyD]: Navigate right; Updates focus; Creates focus trap
   *  [ArrowLeft, KeyA]: Navigate left; Updates focus; Creates focus trap
   *  [Enter, Space]: Piece selection logic flow
   *
   */
  const handleCarouselKeydown = (event) => {
    if (
      event.code === 'Tab' &&
      event.shiftKey === true &&
      scrollIndex - 1 >= 0
    ) {
      event.preventDefault();
      handleTranslation({ direction: -1, autoFocus: true });
    } else if (
      event.code === 'Tab' &&
      event.shiftKey === false &&
      scrollIndex + 1 < itemCountRef.current
    ) {
      event.preventDefault();
      handleTranslation({ direction: 1, autoFocus: true });
    } else if (event.code === 'ArrowRight' || event.code === 'KeyD') {
      handleTranslation({ direction: 1, autoFocus: true });
    } else if (event.code === 'ArrowLeft' || event.code === 'KeyA') {
      handleTranslation({ direction: -1, autoFocus: true });
    } else if (event.code === 'Enter' || event.code === 'Space') {
      handleSelection(event);
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleOnSwipe,
    onSwipedRight: handleOnSwipe,
    preventScrollOnSwipe: true,
    delta: {
      left: '> = 20',
      right: '> = 20',
    },
  });

  const refPassthrough = (el) => {
    swipeHandlers.ref(el);
    sliderRef.current = el;
  };

  const handleViewportResize = useCallback(() => {
    console.log('carouselRef.current', carouselRef.current);
    if (!carouselRef.current) return;
    const newStyles = calculateStyles();
    console.log('newStyles', newStyles);
    setStyles(newStyles);
  }, [calculateStyles]);

  useEffect(() => {
    if (!gridItemProps.ready) return;
    handleViewportResize();
    // handleTranslation({ direction: 0 })
    // eslint-disabxle-next-line react-hooks/exhaustive-deps
  }, [handleViewportResize]);

  useEffect(() => {
    if (!gridItemProps.ready) return;
    handleViewportResize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewport, gridItemProps]);

  useEffect(() => {
    if (!gridItemProps.ready) return;
    const slider = sliderRef.current;
    slider.addEventListener('keydown', handleCarouselKeydown);
    return () => {
      slider.removeEventListener('keydown', handleCarouselKeydown);
    };
  });

  useEffect(() => {
    if (!gridItemProps.ready) return;
    if (carouselItems.length !== itemCountRef.current) {
      itemCountRef.current = carouselItems.length;
      handleTranslation({ direction: 0 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carouselItems]);

  return (
    <div
      className={`GameCarousel ${tile?.width ? '' : ' hide'}`}
      ref={carouselRef}
    >
      <div id="GameCarousel-SliderContainer" className="GameCarousel-Inner">
        <ol
          // role="group"
          title={__t(`puzzlePieceDrawer`)}
          id="GameCarousel-Slider"
          // tabIndex="-1"
          {...swipeHandlers}
          ref={refPassthrough}
          style={{
            gridTemplateColumns: `repeat(${carouselItems.length}, 1fr)`,
            gridColumnGap: `${styles.gridColumnGap}px`,
          }}
        >
          {carouselItems.map((hex) => (
            <GameCarouselItem
              key={hex.id}
              id={`GameCarouselItem__${hex.id}`}
              hex={hex}
              board={board}
              style={styles ? styles.item : null}
              pieceStyle={styles ? styles.piece : null}
              isSelected={selectedHex && HexUtils.equals(selectedHex, hex)}
              onSelect={handleSelection}
              handleOnDrop={handleOnDrop}
              gridItemProps={gridItemProps}
              viewport={viewport}
            />
          ))}
        </ol>
      </div>
    </div>
  );
}

export default GameCarousel;
